// extracted by mini-css-extract-plugin
export default {"Login":"Login__G6tIL80VAOkx","greeting":"greeting__Gxgzq2umQ6NY","tagline":"tagline__bQVKs39kNHd4","loginLink":"loginLink__WeqoTlzH4YCy","loginError":"loginError__yD0n3zRFgfHP"};